// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__19U3T","title":"BackImages_title__60vSP","images":"BackImages_images__qRtyP"};